import apiClient from "../../utils/interceptor";
import {
  ApiResponse,
  ClassData,
  CreateClassParams,
  UpdateClassParams,
  CreateClassResponse,
} from "./interface";
import { API_URLS } from "../../constants";

// Helper to get auth token
const getAuthToken = (): string | null => {
  return localStorage.getItem("auth_token");
};

// Function to get all classes
export const getAllClasses = async (): Promise<ApiResponse<ClassData[]>> => {
  const token = getAuthToken();

  try {
    const response = await apiClient.get<ApiResponse<ClassData[]>>(
      API_URLS.CLASS.GET_CLASSES,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching classes:", error);
    throw error;
  }
};

// Function to create a class
export const createClass = async (
  classParams: CreateClassParams
): Promise<ApiResponse<CreateClassResponse>> => {
  const token = getAuthToken();

  try {
    const response = await apiClient.post<ApiResponse<CreateClassResponse>>(
      API_URLS.CLASS.CREATE_CLASS,
      classParams,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error creating class:", error);
    throw error;
  }
};

// Function to update a class
export const updateClass = async (
  classData: UpdateClassParams
): Promise<ApiResponse<null>> => {
  const token = getAuthToken();

  try {
    const response = await apiClient.patch<ApiResponse<null>>(
      API_URLS.CLASS.UPDATE_CLASS,
      classData,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error updating class:", error);
    throw error;
  }
};

// Function to delete a class
export const deleteClass = async (
  classId: string
): Promise<ApiResponse<null>> => {
  const token = getAuthToken();

  try {
    const response = await apiClient.delete<ApiResponse<null>>(
      API_URLS.CLASS.DELETE_CLASS,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        data: { class_id: classId },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error deleting class:", error);
    throw error;
  }
};
